import { useEffect, useState } from 'react';
import { COUNTDOWN_INTERVAL, INITIAL_COUNTDOWN } from 'common/constants/auth';
import type { UseAuthSuccessCountdownOptions } from './useAuthSuccessCountdown.types';

const useAuthSuccessCountdown = ({
  enabled,
  initialCountdown = INITIAL_COUNTDOWN,
  loop = false,
  onComplete,
}: UseAuthSuccessCountdownOptions) => {
  const [countdown, setCountdown] = useState(initialCountdown);

  useEffect(() => {
    setCountdown(initialCountdown);
  }, [enabled, initialCountdown]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    if (countdown <= 1) {
      if (loop) {
        const timeoutId = window.setTimeout(() => {
          setCountdown(initialCountdown);
        }, COUNTDOWN_INTERVAL);

        return () => window.clearTimeout(timeoutId);
      }

      onComplete?.();
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setCountdown(previousCountdown => previousCountdown - 1);
    }, COUNTDOWN_INTERVAL);

    return () => window.clearTimeout(timeoutId);
  }, [countdown, enabled, initialCountdown, loop, onComplete]);

  return countdown;
};

export default useAuthSuccessCountdown;
